import {
  ProcessTypeEnum,
  type ApplicationContractResponse,
  type ApplicationResponse,
} from '@acme/api';
import { Field, formatDateTime } from '@acme/foundation';

export const ApplicationBaseInfo = ({
  application,
  contract,
}: {
  application: ApplicationResponse;
  contract: ApplicationContractResponse | null;
}) => {
  return (
    <>
      <div className="grid grid-cols-3 gap-6">
        <Field
          label="Тип заявки"
          value={
            application?.processType?.id === ProcessTypeEnum.Incoming
              ? 'Входящая'
              : 'Исходящая'
          }
        />
        <Field label="Контрагент" value={contract?.counterparty ?? '-'} />
        <Field
          label="Предмет сделки"
          value={contract?.subjectTransaction ?? '-'}
        />

        {/* <Field
            label="Создана"
            value={
              application.createdAt
                ? formatDateTime(application.createdAt)
                : '-'
            }
          />
          <Field
            label="Изменена"
            value={
              application.updatedAt
                ? formatDateTime(application.updatedAt)
                : '-'
            }
          /> */}
      </div>
    </>
  );
};
